/**
 * @file surcharges.api.js
 * @module SurchargesAPI
 * @description HTTP API wrapper for surcharge related endpoints. Methods return Axios promises.
 */

import { axiosInstance } from "./axios";

export const SurchargesAPI = {
    /**
     * Create a new surcharge.
     * @param {Object} surcharge - Surcharge payload.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to created surcharge.
     */
    createSurcharge: (surcharge, token = "") => {
        return axiosInstance(token).post(`/surcharges`, surcharge);
    },

    /**
     * Get a surcharge by id.
     * @param {string} surchargeId - Surcharge identifier.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to surcharge data.
     */
    getSurchargeById: (surchargeId, token = "") => {
        return axiosInstance(token).get(`/surcharges/${surchargeId}`);
    },

    /**
     * Update a surcharge by id.
     * @param {string} surchargeId - Surcharge identifier.
     * @param {Object} surcharge - Updated surcharge payload.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to updated surcharge.
     */
    updateSurchargeById: (surchargeId, surcharge, token = "") => {
        return axiosInstance(token).put(`/surcharges/${surchargeId}`, surcharge);
    },

    /**
     * Delete a surcharge by id.
     * @param {string} surchargeId - Surcharge identifier.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise indicating deletion result.
     */
    deleteSurchargeById: (surchargeId, token = "") => {
        return axiosInstance(token).delete(`/surcharges/${surchargeId}`)
    },

    /**
     * Patch attributes of a surcharge by id.
     * @param {string} surchargeId - Surcharge identifier.
     * @param {Object} payload - Partial payload with attributes to update.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to updated surcharge.
     */
    updateAnyAttributeById: (surchargeId, payload, token = "") => {
        return axiosInstance(token).patch(`/surcharges/${surchargeId}`, payload);
    }
}
